/**
 * Spacing rhythm for the dashboard screens — Home and Team performance.
 *
 * The list screens (Sales, Listings, Earnings) run tight on purpose: their job is
 * to fit as many rows on a phone as possible, so 12px gutters and 11px rows are
 * right there. A dashboard is the opposite shape — a stack of unlike blocks, each
 * a separate idea — and at list density they read as one undifferentiated wall,
 * with nothing telling the eye where the money ends and the queue begins.
 *
 * These steps are deliberately roomier than the list pages. The radii stay inside
 * the app's existing 14/16 family so the cards are still recognisably the same
 * cards, and `row` stays tighter than `block` so a list nested inside a dashboard
 * still reads as a list rather than as more blocks.
 *
 * `page` is load-bearing beyond padding: a sticky header inside the scroll
 * container bleeds to the gutters with `margin: 0 -{page}px`. Change one and the
 * other must follow, or the bar stops covering the content passing behind it.
 */
export const S = {
  page: 18,          // scroll-container side padding (and the sticky bleed)
  block: 18,         // between top-level blocks
  row: 10,           // between rows of one list, and label → its card
  grid: 12,          // between cards inside a grid row
  radius: 16,
  cardPad: '15px 16px',
  rowPad: '15px 16px',
  tilePad: '14px 14px 13px',
};

/**
 * Type scale.
 *
 * The app had accumulated sixteen distinct font sizes between 8px and 13px,
 * chosen a screen at a time — 9.5 here, 10.5 there, 8 in a sheet — so the same
 * kind of label was a different size depending on which page you reached it
 * from, and the smallest of them were genuinely hard to read on a phone held at
 * arm's length.
 *
 * Five steps replace them. `micro` is the floor: nothing in the app should be
 * smaller, and it is only for uppercase tracked-out labels and badges, never for
 * a sentence. The steps are far enough apart to read as deliberate levels rather
 * than as drift.
 */
export const T = {
  micro: 10.5,  // UPPERCASE eyebrows, chips, badge counts
  small: 11.5,  // secondary/muted lines under a title
  body: 13,     // default reading size for row titles and card copy
  lead: 15,     // emphasised value inside a row
  figure: 18,   // the number a card exists to show
};

export default S;
